import { takeLatest, call, select, put } from 'redux-saga/effects';
import { saveUserProgress, getUserProgress, updateUserSteps, removeUser, setToken } from 'api';
import { push } from 'react-router-redux';

import { TELEPHONE_CODE, URLS } from 'config';

import { saveUser, logout, resetStore } from 'pages/Login/actions';


import * as actions from './actions';

function* sendHandl(action) {
  const state = yield select();
  const { payload: { lastRoute } } = action;
  const { phone: { phone } } = state;

  try {
    yield call(saveUserProgress, lastRoute, `${TELEPHONE_CODE}${phone}`);
  } catch (err) {
    console.log(err);
  }
}

function* getHandl(action) {
  const { payload: { cb } } = action;

  try {
    const result = yield call(getUserProgress);
    if (cb) cb(result.data.lastRoute);
  } catch (err) {
    console.log(err);
  }
}

function* removeUserHandl() {
  // const { payload: { cb } } = action;

  try {
    const result = yield call(removeUser);
    yield put(saveUser(result.data.user));
    yield put(logout());
    yield put(push(URLS.BASE));
    yield put(resetStore(true));
    setToken();
    localStorage.removeItem('carsapp');
    // console.log(result.data.user);
    // if (cb) cb(result.data.user);
  } catch (err) {
    console.log(err);
  }
}

function* updateUserHandl() {
  const state = yield select();

  const {
    phone: { phone },
    carType: { carType },
    budget: { budget },
    needs: { needs }
  } = state;
  const body = {
    telephoneNumber: `${TELEPHONE_CODE}${phone}`,
    typeOfCar: carType,
    userMonthlyBudget: budget,
    whyUserNeedCar: needs.filter(el => el !== '')
  };

  try {
    const result = yield call(updateUserSteps, body);
    yield put(saveUser(result.data.user));

    yield put(push(URLS.NAME));
  } catch (err) {
    console.log(err);
  }
}

export default function* () {
  yield takeLatest(
    actions.SAVE_PROGRESS,
    sendHandl
  );
  yield takeLatest(
    actions.GET_PROGRESS,
    getHandl
  );
  yield takeLatest(
    actions.UPDATE_USER,
    updateUserHandl
  );
  yield takeLatest(
    actions.REMOVE_USER,
    removeUserHandl
  );
}



// WEBPACK FOOTER //
// ./src/pages/Login/saga.js